import { earnPointResponse, useEarnNRegister, useSendOtp } from "@/app/api"
import { RootState } from "@/app/store"
import { changeEarnPointResponse } from "@/app/appSlice"

export default function Otp() {
  const sendOtpInterval = 60

  const t = useTranslate()
  const nav = useNavigate()
  const dispatch = useAppDispatch()
  const earnNRegister = useEarnNRegister()
  const sendOtp = useSendOtp()

  const [otp, setOtp] = useState(Array(6).fill(""))
  const [errorMessage, setErrorMessage] = useState("")
  const [timer, setTimer] = useState(sendOtpInterval)
  const [buttonEnabled, setButtonEnabled] = useState(false)

  const phone = useAppSelector((state: RootState) => state.app.phone)
  const txnGA = useAppSelector((state: RootState) => {
    return { ...state.app.txnGA, invoiceQRCode: state.app.invoiceQRCode }
  })

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1)
      }, 1000)
      return () => clearInterval(interval)
    }
  }, [timer])

  const validateOTP = async () => {
    window.gtag("event", "validate_otp", { ...txnGA })
    const otp_ = otp.join("")
    let res: earnPointResponse | null = null
    try {
      res = await earnNRegister({ phone, otp: otp_ })
    } catch (e: any) {
      setErrorMessage(e)
      return
    }
    dispatch(changeEarnPointResponse(res))
    nav("/success")
  }

  const handleChange = (element: HTMLInputElement, index: number) => {
    if (element.value === " " || isNaN(Number(element.value))) return

    const newOtp = [...otp]
    newOtp[index] = element.value
    setOtp(newOtp)
    setButtonEnabled(newOtp.every((data) => data !== ""))

    if (element.nextSibling && element.value) {
      ;(element.nextSibling as HTMLInputElement).focus()
    }
  }

  const handleKeyDown = (
    element: HTMLInputElement,
    index: number,
    event: React.KeyboardEvent,
  ) => {
    if (
      event.key === "Backspace" &&
      !element.value &&
      element.previousSibling
    ) {
      ;(element.previousSibling as HTMLInputElement).focus()
    }
  }

  const onResend = async () => {
    try {
      await sendOtp()
      setErrorMessage("")
      setTimer(sendOtpInterval)
    } catch (e: any) {
      setErrorMessage(e)
    }
  }

  return (
    <div className="body">
      <p className="text1">{t("verifyPhoneNumber")}</p>
      <p className="text2">{t("receiveOtp")}</p>
      <div className="otp-container mt-4">
        {otp.map((data, index) => (
          <input
            key={index}
            type="text"
            name="otp"
            maxLength={1}
            value={data}
            onChange={(e) => handleChange(e.target as HTMLInputElement, index)}
            onKeyDown={(e) =>
              handleKeyDown(e.target as HTMLInputElement, index, e)
            }
            className={`otp-input ${errorMessage ? "border-red-500" : ""}`}
          />
        ))}
      </div>
      {timer > 0 ? (
        <p className="text2 text-left mt-2">
          {t("haventReceivedOtp")}
          {t("retryFirstHalf")}
          {`0${Math.floor(timer / 60)}`.slice(-2)}:{`0${timer % 60}`.slice(-2)}{" "}
          {t("retrySecondHalf")}
        </p>
      ) : (
        <p className="text2 text-left mt-2">
          {t("haventReceivedOtp")}
          <a href="#" onClick={onResend} className="link">
            {t("resendOtp")}
          </a>
        </p>
      )}
      {errorMessage && <p className="text-error">{errorMessage}</p>}
      <button
        className="confirm-button"
        disabled={!buttonEnabled}
        onClick={validateOTP}
      >
        {t("verify")}
      </button>
    </div>
  )
}
